import { createSelector } from "reselect";
import { buildQueryString } from "src/utils/build_query_string";
import { createCustomRolesGetPayload } from "src/api/custom_roles";

export function customRolesQuerySelector() {
  return createSelector(() => {
    return buildQueryString(createCustomRolesGetPayload());
  });
}
